import VueRouter, { Route } from 'vue-router'
import trackPageView from '../middleware/analytics/after/trackPageView'

type NavigationAfter = (to: Route, any: Route) => any

export const afterMiddleware: NavigationAfter[] = [trackPageView]

export function applyMiddleware(router: VueRouter): void {
    router.afterEach(applyAfterMiddleware)
}

export const applyAfterMiddleware = (to: Route, from: Route) => {
    afterMiddleware.forEach((m: NavigationAfter) => m(to, from))
}
